<div class="main_content">
    <div class="dialog-header">
      <h2 mat-dialog-title>Filter</h2>
    </div>

    <div class="calendar_content">
      <mat-dialog-content>
        <div class="date-pickers-container">
          <div class="date-picker-group">
            <label class="date-label">From</label>
            <mat-form-field appearance="outline">
              <input 
                matInput [matDatepicker]="startPicker" 
                [(ngModel)]="startDate" 
                name="startDate"
                placeholder="dd/MM/yyyy">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="date-picker-group">
            <label class="date-label">To</label>
            <mat-form-field appearance="outline">
              <input 
                matInput [matDatepicker]="endPicker" 
                [(ngModel)]="endDate"
                name="endDate" 
                placeholder="dd/MM/yyyy">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="filter-and-controls">
          <div class="preset-filters">
              <button mat-stroked-button (click)="setToday()">Today</button>
              <button mat-stroked-button (click)="setThisWeek()">This week</button>
              <button mat-stroked-button (click)="setThisMonth()">This Month</button>
            </div>
            <div class="controllers">
              <mat-dialog-actions>
                <button mat-stroked-button class="reset-button" (click)="resetDates()">Reset</button>
                <button mat-flat-button class="apply-button" (click)="onApply()">Apply</button>
              </mat-dialog-actions>
            </div>
        </div>
      </mat-dialog-content>
    </div>
</div>